module.exports = __webpack_public_path__ + "img/inspiration.c7313c84.png";